// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
:host {
  display: block;
  width: 100%;
  position: relative;
  font-family: Helvetica, Arial, sans-serif;
}

:host.small {
  width: 285px;
  max-width: 100%;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  height: 45px;
  padding: 0 14px;
  box-sizing: border-box;
  border: none;
  border-radius: 5px;
  background: #3b5873;
  color: #9dbcda;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  text-align: left;
  cursor: pointer;
}
.dropdown-trigger:disabled {
  background: #3f5061;
  color: #607387;
  cursor: default;
}
.dropdown-trigger:focus-visible {
  outline: 2px solid #52aaff;
  outline-offset: 1px;
}

.dropdown-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-chevron {
  flex: 0 0 auto;
  transition: transform 120ms ease;
}
.dropdown-chevron.open {
  transform: rotate(180deg);
}

.dropdown-panel {
  position: fixed;
  z-index: 1000;
  overflow: auto;
  box-sizing: border-box;
  margin: 0;
  padding: 8px 0 10px;
  border-radius: 5px;
  background: #3b5873;
  color: #9dbcda;
  font-family: Helvetica, Arial, sans-serif;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
}

.dropdown-group {
  padding: 14px 16px 4px;
  color: #dce8f3;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}

.dropdown-option {
  display: block;
  width: 100%;
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: #9dbcda;
  font-family: inherit;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.35;
  text-align: left;
  cursor: pointer;
}
.dropdown-option:hover {
  background: #607387;
}
.dropdown-option.selected {
  background: #23739f;
  color: #dce8f3;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
